import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';

const GlobalBrandEdit = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const BASE_URL = "https://cyberathon.com/multivendor/";

  const [formData, setFormData] = useState({
    image: null,
    logo: null,
    discount: '',
  });

  const [previewImage, setPreviewImage] = useState(null);
  const [previewLogo, setPreviewLogo] = useState(null);
  const [loading, setLoading] = useState(false);

  // Fetch brand by ID
  useEffect(() => {
    const fetchBrand = async () => {
      try {
        setLoading(true);
        const response = await axios.post(
          "https://cyberathon.com/multivendor/index.php/Api/Master_controller/get_global_brand",
          { brand_id: id }
        );

        if (response.data.status) {
          const brand = response.data.data;
          setFormData({
            image: null,
            logo: null,
            discount: brand.discount,
          });
          setPreviewImage(`${BASE_URL}${brand.global_brand_image}`);
          setPreviewLogo(`${BASE_URL}${brand.brand_logo}`);
        } else {
          toast.error("Failed to fetch brand details");
          navigate("/GlobalBrand-list");
        }
      } catch (error) {
        console.error("Error fetching brand:", error);
        toast.error("Something went wrong while fetching data");
      } finally {
        setLoading(false);
      }
    };

    if (id) fetchBrand();
  }, [id, navigate]);

  // Handle text field
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  // Handle file input
  const handleFileChange = (e, field) => {
    const file = e.target.files[0];
    if (file) {
      setFormData(prev => ({ ...prev, [field]: file }));
      if (field === "image") setPreviewImage(URL.createObjectURL(file));
      if (field === "logo") setPreviewLogo(URL.createObjectURL(file));
    }
  };

  // Handle submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.discount) {
      alert("Discount is required");
      return;
    }

    try {
      setLoading(true);
      const data = new FormData();
      data.append("brand_id", id);
      if (formData.image) data.append("global_brand_image", formData.image);
      if (formData.logo) data.append("brand_logo", formData.logo);
      data.append("discount", formData.discount);

      const response = await axios.post(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/update_global_brand",
        data,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      if (response.data.status) {
        toast.info("Brand updated successfully!");
        navigate("/GlobalBrand");
      } else {
        toast.error(response.data.message || "Failed to update brand");
      }
    } catch (error) {
      console.error("Error updating brand:", error);
      toast.error("Something went wrong while updating");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-content">
      <div className="container-fluid">
        <div className="page-title-box">
          <h4 className="mb-0 fw-semibold">Edit Global Brand</h4>
          <ol className="breadcrumb mb-0">
            <li className="breadcrumb-item"><a href="#">Global Brand</a></li>
            <li className="breadcrumb-item active">Edit</li>
          </ol>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="card">
            <div className="card-header">
              <h4 className="card-title">Edit Global Brand</h4>
            </div>
            <div className="card-body row">
              <div className="col-lg-6 mb-3">
                <label className="form-label">Main Image</label>
                <input
                  type="file"
                  className="form-control"
                  accept="image/*"
                  onChange={(e) => handleFileChange(e, "image")}
                />
                {previewImage && (
                  <img src={previewImage} alt="Preview" height="80" className="mt-2" />
                )}
              </div>

              <div className="col-lg-6 mb-3">
                <label className="form-label">Brand Logo</label>
                <input
                  type="file"
                  className="form-control"
                  accept="image/*"
                  onChange={(e) => handleFileChange(e, "logo")}
                />
                {previewLogo && (
                  <img src={previewLogo} alt="Logo" height="80" className="mt-2" />
                )}
              </div>

              <div className="col-lg-6 mb-3">
                <label className="form-label">Discount</label>
                <input
                  type="text"
                  name="discount"
                  value={formData.discount}
                  onChange={handleChange}
                  className="form-control"
                  placeholder="e.g., 50% Off"
                  required
                />
              </div>
            </div>

            <div className="card-footer">
              <button type="submit" className="btn btn-primary" disabled={loading}>
                {loading ? "Updating..." : "Update Global Brand"}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default GlobalBrandEdit;
